import Footer from "../../components/Footer/footer"
import Faq from "../../components/FaleConosco/faleconosco"
import './Faq.css'
import HeaderFaq from '../../components/FaleConosco/headerFaq/headerFaq'
export default function FaleConosco() {
    return (
        <>
            <HeaderFaq />
            <Faq />
            <Footer />
        </>
    )
}